import './MapSidebar.css';

interface MapSidebarProps {
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const MapSidebar = ({ isOpen, onToggle, children }: MapSidebarProps) => {
  return (
    <>
      <div className={`map-sidebar ${isOpen ? 'open' : 'closed'}`}>
        <button className="sidebar-toggle" onClick={onToggle} title={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}>
          {isOpen ? '◀' : '▶'}
        </button>

        {isOpen && (
          <div className="sidebar-content">
            {children}
          </div>
        )}
      </div>
    </>
  );
};

export default MapSidebar;
